// @flow
import {pick} from 'lodash';
import tripActions from '../../actions/trip';
import type {TripQuery} from '../../utils/tripData';
import {
    tripDataFields,
    cookieDataFromQueryData,
    TRIPDATA_COOKIE
} from '../../utils/tripData';
import cookieUtils from '../../utils/cookieUtils';
import type {Store} from '../../reducers';

const tripDataDidChange = (
    store: Store,
    action: {type: string, payload: Object}
) => {
    const newTripData: TripQuery = pick(action.payload.params, tripDataFields);
    const cookieData = cookieDataFromQueryData(newTripData);

    cookieUtils.writeCookie(TRIPDATA_COOKIE, cookieData);

    /* Update our state to match the new cookie */
    store.dispatch(tripActions.tripDataChanged(newTripData));
};

export default tripDataDidChange;
